export default __webpack_public_path__ + "static/media/unexp.a7739f5a.png";